import React from 'react';
import classes from './Button.module.scss';

import Aux from '../../hoc/Aux';

const button = ( props ) => {

    let addClasses = [];

    if( props.addClass ) {
        addClasses.push( props.addClass );
    }

    const buttonDisabled = ( props.buttonDisabled ) ? props.buttonDisabled : '';

    if( props.textLink ) {
        addClasses.push( classes.TextLink );
    }

    return (
        <Aux>
            <button className={[classes.Button,...addClasses].join(' ')}
                    onClick={() => ( props.hasOwnProperty('onButtonClick') ) ? props.onButtonClick() : null}
                    type={props.buttonType || "button"}
                    disabled={buttonDisabled}
                    >{props.children}</button>
        </Aux>
    );

};

export default button;
